import { erpAxios } from '.';

const getMjesnaZajednicaByOpcina = async (city) => {
  const { data } = await erpAxios(`/prostori/mjesne-zajednice-po-gradu/${city}`);
  return data;
};

export default getMjesnaZajednicaByOpcina;
